import { useDispatch, useSelector } from 'react-redux'
import { FootballGradeFacet, NFLWeekAbbreviation, VisitedEvents } from '@pff-consumer/schema'
import { connectActions, connectSelectors } from './connect.slice'

export const connectHooks = {
  useGetEventScores: () => useSelector(connectSelectors.getEventScores),
  useGetEventScoreById: (eventId: number) => useSelector(connectSelectors.getEventScoreById(eventId)),
  useGetSelectedWeek: () => useSelector(connectSelectors.getSelectedWeek),
  useGetSelectedSeason: () => useSelector(connectSelectors.getSelectedSeason),
  useGetSelectedEvent: () => useSelector(connectSelectors.getSelectedEvent),
  useGetSelectedPlayerPosition: () => useSelector(connectSelectors.getSelectedPlayerPosition),
  useGetSelectedPlayer: () => useSelector(connectSelectors.getSelectedPlayer),
  useGetSelectedTeamAbv: () => useSelector(connectSelectors.getSelectedTeamAbv),
  useGetPFFLivePlayers: () => useSelector(connectSelectors.getPFFLivePlayers),
  useGetRecentPlayerSearch: () => useSelector(connectSelectors.getRecentPlayerSearch),
  useGetVisitedEventsTimestamp: () => useSelector(connectSelectors.getVisitedEventsTimestamp),
  useGetPlayerHalftimeAvgReceivingMetric: (playerId: number) =>
    useSelector(connectSelectors.getPlayerHalftimeReceivingMetric(playerId)),
  useGetPlayerHalftimeAvgRushingMetric: (playerId: number) =>
    useSelector(connectSelectors.getPlayerHalftimeRushingMetric(playerId)),
  useGetPlayerGradeById: (playerId: number, facet: FootballGradeFacet) =>
    useSelector(connectSelectors.getPlayerGradeById(playerId, facet)),
  useGetLivePassRateGameNarratives: (eventId: number) =>
    useSelector(connectSelectors.getLivePassRateGameNarratives(eventId)),
  useGetLivePressureRateGameNarratives: (eventId: number) =>
    useSelector(connectSelectors.getLivePressureRateGameNarratives(eventId)),
  useGetPreGameNarratives: (eventId: number) => useSelector(connectSelectors.getPreGameNarratives(eventId)),
  useGetGameScripts: () => useSelector(connectSelectors.getGameScripts),
  useConnectActions: () => {
    const dispatch = useDispatch()
    return {
      setSelectedWeek: (payload: NFLWeekAbbreviation) => {
        dispatch(connectActions.setSelectedWeek(payload))
        dispatch(connectActions.setSelectedEvent())
      },
      setSelectedSeason: (payload: number) => {
        dispatch(connectActions.setSelectedSeason(payload))
      },
      setSelectedEvent: (payload?: number) => {
        dispatch(connectActions.setSelectedEvent(payload))
      },
      setSelectedPlayerPosition: (payload: string) => {
        dispatch(connectActions.setSelectedPlayerPosition(payload))
      },
      setSelectedPlayer: (payload: number) => {
        dispatch(connectActions.setSelectedPlayer(payload))
      },
      setRecentPlayerSearch: (payload: number[]) => {
        dispatch(connectActions.setRecentPlayerSearch(payload))
      },
      setVisitedEventsTimestamp: (payload: VisitedEvents) => {
        dispatch(connectActions.setVisitedEventsTimestamp(payload))
      },
      setSelectedTeamAbv: (payload: string | null) => {
        dispatch(connectActions.setSelectedTeamAbv(payload))
      },
    }
  },
}
